import * as React from 'react';
import StaticView from './StaticView';
import { CaretDownOutlined } from '@ant-design/icons';
import { Cascader } from 'antd';
import statics from 'common/statics';
import ControlApi from 'common/api/control';
import { languages } from "common/i18n";

/**
 * 组件说明
 * 1.使用国家地区联动功能，需要属性loadCountry。
 * 2.options不传，默认取值为国家一级。此用法适用于不需要取旧值。
 * 3.传入options，只需要传入国家列表即可。
*/
export default class Cascade extends React.Component<any> {
    private mounted: boolean;
    static fieldName = 'cascade';
    static type = 'Select';
    static validateTrigger = 'onChange';
    public static defaultProps = {
        size: 'default'
    };

    state: any = {
        value: this.props.value,
        asyncOptions: []
    };
    changeHandler = (value: any, selectedOptions: any) => {
        this.mounted && this.setState({ value: value });
        const { onChange } = this.props;
        if (onChange) onChange(value);
    };
    loadDataHandler = async (selectedOptions: any) => {
        this.mounted && this.setState({ selectedOptions: selectedOptions });
        const { loadCountry, loadData } = this.props;
        if (loadCountry) {
            await this.loadCountry(selectedOptions);
        } else if (loadData) {
            loadData(selectedOptions);
        }
    };

    // 国家地区三级联动
    loadCountry = async (selectedOptions: any) => {
        let provinceList = [];
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        statics.get('area', async (countryList: Array<any> = []) => {
            if (selectedOptions.length === 1) {
                const selectCountry = countryList.find((item: any) => item.value === targetOption.value);
                provinceList = await ControlApi.province({ lang: languages.getDefault(), country_id: selectCountry.id });
                targetOption.children = provinceList;
            } else if (selectedOptions.length === 2) {
                const cityList = await ControlApi.city({ lang: languages.getDefault(), province_id: targetOption.value });
                targetOption.children = cityList;
            }
            targetOption.loading = false;
            this.setState({
                asyncOptions: [...this.state.asyncOptions]
            });
        });
    };

    getTreeDesc = (location: any[], values: any[]) => {
        let ret: any[] = [];
        // 兼容无国家数据
        if (!values[0] && this.props.staticValue) return this.props.staticValue;
        const getStaticView = (items: any[], deepIndex: number) => {
            for (let { value, label, children } of items) {
                if (value === values[deepIndex]) {
                    ret.push(label);
                    Array.isArray(children) && getStaticView(children, deepIndex + 1);
                    return;
                }
            }
        };
        getStaticView(location, 0);
        return ret.join('/');
    };

    componentDidMount() {
        this.mounted = true;
        const { options } = this.props;
        if (options) {
            this.setState({ asyncOptions: options });
        } else {
            statics.get('area', (asyncOptions: Array<any> = []) => this.mounted && this.setState({ asyncOptions }));
        }
    }

    UNSAFE_componentWillReceiveProps({ value, options }: any) {
        const { asyncOptions } = this.state;
        if (this.mounted) {
            if (!asyncOptions.length && options && options.length) this.setState({ asyncOptions: options });
            if (this.props.value !== value) this.setState({ value: value });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    // 兼容以前的数据
    handlerValue = () => {
        const { value } = this.props;
        return typeof value === 'string' ? [value] : (value && !!value[0]) ? value : undefined;
    };

    render() {
        const { value, asyncOptions } = this.state;
        const { placeholder, disabled, size, changeOnSelect, formatFn, staticView, initialValue, displayRender } = this.props;
        return (
            <Cascader value={this.handlerValue()}
                options={formatFn ? formatFn(asyncOptions) : asyncOptions}
                placeholder={placeholder}
                loadData={this.loadDataHandler}
                disabled={disabled}
                size={size}
                defaultValue={initialValue}
                changeOnSelect={changeOnSelect}
                onChange={this.changeHandler}
                displayRender={displayRender}
                suffixIcon={<CaretDownOutlined />}>
                {staticView && disabled && <StaticView display={value ? this.getTreeDesc(asyncOptions, value) : '-'} />}
            </Cascader>
        );
    }
}
